import { TextSmall } from '@/components/Texts';
import React from 'react';

const Contact = () => {
  return (
    <>
      <TextSmall fontWeight={700}>(9) Contact</TextSmall>
      <TextSmall>
        Questions, comments and requests regarding this Privacy Statement should
        be addressed to our customer support service or by email to
        support@diment.io or EEA customers: Should you have any concerns about
        how we handle your Personal Information, please contact us in the first
        instance by opening a customer support ticket or sending an email
        support@diment.io We will do our best to resolve your concern. You can
        also submit a complaint to the national supervisory authority within
        your jurisdiction, details of which can be found online.
      </TextSmall>
    </>
  );
};

export default Contact;
